import { Box, useTheme } from '@material-ui/core';
import React from 'react';

function ManagementPanel({
  schoolRegistered,
  schoolOnboard,
  admisssions,
  enquiries,
}) {
  const theme = useTheme();
  return (
    <Box
      maxWidth={950}
      width={'100%'}
      border={1}
      display="flex"
      borderColor={theme.palette.buzzBorder}
      p={2}>
      <Box flex={1} borderRight={`1px solid ${theme.palette.buzzBorder}`}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          School Registered
        </Box>
        <Box fontSize={36} fontWeight={'fontWeightMedium'}>
          {schoolRegistered}
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        borderRight={`1px solid ${theme.palette.buzzBorder}`}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          School Onboarded
        </Box>
        <Box
          minWidth={130}
          display={'flex'}
          justifyContent={'center'}
          fontSize={36}
          fontWeight={'fontWeightMedium'}>
          {schoolOnboard}
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        borderRight={`1px solid ${theme.palette.buzzBorder}`}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          Admissions
        </Box>
        <Box
          minWidth={130}
          display={'flex'}
          justifyContent={'center'}
          fontSize={36}
          fontWeight={'fontWeightMedium'}>
          {admisssions}
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" flex={1}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          Enquiries
        </Box>
        <Box
          minWidth={120}
          fontSize={36}
          display={'flex'}
          justifyContent={'center'}
          fontWeight={'fontWeightMedium'}>
          {enquiries}
        </Box>
      </Box>
    </Box>
  );
}

export default ManagementPanel;
